'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

// 같은 탭에서 발생한 pathname 변경 횟수를 sessionStorage 에 누적한다.
// 트래커는 (internal) 레이아웃에 마운트되어 있어 첫 진입 시 useEffect 가 한 번
// 발화하므로 cold-start 단독 진입 상태에서는 count === 1 이다. 같은 pathname 으로
// 재마운트되는 경우는 중복 집계하지 않고, 실제 pathname 이 바뀔 때만 +1 한다.
export const SPA_NAV_COUNT_KEY = 'podo-spa-nav-count'
const SPA_NAV_PATH_KEY = 'podo-spa-nav-path'

export const SpaHistoryTracker = () => {
  const pathname = usePathname()

  useEffect(() => {
    if (typeof sessionStorage === 'undefined') {
      return
    }

    if (sessionStorage.getItem(SPA_NAV_PATH_KEY) === pathname) {
      return
    }

    const current = Number(sessionStorage.getItem(SPA_NAV_COUNT_KEY) ?? '0')
    sessionStorage.setItem(SPA_NAV_COUNT_KEY, String(current + 1))
    sessionStorage.setItem(SPA_NAV_PATH_KEY, pathname)
  }, [pathname])

  return null
}
